/*
  Dos textos que se turnan (<site-label-swap>): el comportamiento de snippets/site-label-swap.liquid.
  · Cada 3 s (6 s con "reducir movimiento") el que se ve sale (.is-out, hacia arriba) y entra el otro (.is-on, desde
    abajo); el que salió vuelve abajo sin animarse, listo para la próxima. Con la pestaña escondida no cambia.
*/
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

class SiteLabelSwap extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('.ss-i')];
    if (this.items.length < 2 || this._t) return;
    this.i = 0;
    this.tick = () => {
      if (!document.hidden) this.next();
      this._t = setTimeout(this.tick, reduce.matches ? 6000 : 3000);
    };
    this._t = setTimeout(this.tick, 3000);
  }

  disconnectedCallback() {
    clearTimeout(this._t);
    this._t = null;
  }

  next() {
    const out = this.items[this.i];
    this.i = (this.i + 1) % this.items.length;
    const inn = this.items[this.i];
    inn.classList.remove('is-out');
    out.classList.remove('is-on');
    out.classList.add('is-out');
    inn.classList.add('is-on');
    /* el que salió vuelve abajo sin transición cuando terminó de irse */
    setTimeout(() => {
      if (out.classList.contains('is-on')) return;
      out.style.transition = 'none';
      out.classList.remove('is-out');
      void out.offsetWidth;
      out.style.transition = '';
    }, 650);
  }
}

if (!customElements.get('site-label-swap')) customElements.define('site-label-swap', SiteLabelSwap);
